import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { connectorById } from 'scaleflow/utils/connectors-config';

class ConnectorsGitlabRoute extends Route {
  model() {
    return {
      connector: connectorById('gitlab'),
      integrations: this.modelFor('connectors'),
    };
  }
}

export default instrumentRoutePerformance(ConnectorsGitlabRoute);
